import { $isCodeNode } from '@lexical/code';
import { $isLinkNode, LinkNode } from '@lexical/link';
import { $dfs } from '@lexical/utils';
import { restoreEscapedMarkdownPunctuation } from '@main/shared/utils';
import { $isTextNode, LexicalNode, TextNode } from 'lexical';

import { restorePreservedEmptyParagraphs } from './preserve-newlines';

export function restoreEscapedMarkdownPunctuationInDocument() {
  restorePreservedEmptyParagraphs();
  for (const { node } of $dfs()) {
    if ($isTextNode(node)) {
      restoreTextNode(node);
    } else if ($isLinkNode(node)) {
      restoreLinkNode(node);
    }
  }
}

function restoreTextNode(textNode: TextNode) {
  const text = textNode.getTextContent();
  const restoredText = restoreEscapedMarkdownPunctuation(text, {
    preserveEscape: textNode.hasFormat('code') || hasCodeBlockAncestor(textNode),
  });
  if (restoredText !== text) {
    textNode.setTextContent(restoredText);
  }
}

// The link transformer reads `\(`, `\)`, and `\\` in a destination or title as escapes, but the
// placeholders replaced them before Lexical ran, so the node keeps them unless restored here.
function restoreLinkNode(linkNode: LinkNode) {
  const url = linkNode.getURL();
  const restoredUrl = restoreEscapedMarkdownPunctuation(url);
  if (restoredUrl !== url) {
    linkNode.setURL(restoredUrl);
  }

  const title = linkNode.getTitle();
  if (title === null) {
    return;
  }
  const restoredTitle = restoreEscapedMarkdownPunctuation(title);
  if (restoredTitle !== title) {
    linkNode.setTitle(restoredTitle);
  }
}

function hasCodeBlockAncestor(node: LexicalNode) {
  let parent = node.getParent();
  while (parent) {
    if ($isCodeNode(parent)) {
      return true;
    }
    parent = parent.getParent();
  }

  return false;
}
